/**
 * Sdp modification
 * @module Sdp
 */
export function preferH264(originalSDP) {
    var separator = "\r\n";
    var lines = originalSDP.split(separator);
    lines.pop();
    var videoLine = null;
    var processingVideoSection = false;
    lines.forEach(function (line, index) {
        if (line.indexOf('m=video') === 0) {
            videoLine = index;
            processingVideoSection = true;
            return;
        }
        else if (line.indexOf('m=') === 0) {
            processingVideoSection = false;
        }
        if (!processingVideoSection) {
            return;
        }
        var matched = line.match(/a=rtpmap:([\d]+) H264/i);
        if (matched) {
            lines[videoLine] = lines[videoLine].replace(/(m=video [\d]+ [a-zA-Z\/]+) ([\d ]+)+/, function (_, str, codecs) {
                return str + " " +
                    (matched[1] + " " +
                        codecs
                            .split(" ")
                            .filter(function (codec) { return ![matched[1]].includes(codec); })
                            .join(" "));
            });
            processingVideoSection = false;
        }
    });
    var newSDP = "";
    lines.forEach(function (line) {
        newSDP += line + separator;
    });
    return newSDP;
}
export function modifySdpForMusic(originalSDP) {
    var newSDP = "";
    var separator = "\r\n";
    var lines = originalSDP.split(separator);
    lines.pop();
    var audio_section_counter = 0;
    var processingAudioSection = false;
    lines.forEach(function (line) {
        if (line.indexOf('m=audio') === 0) {
            processingAudioSection = true;
            audio_section_counter++;
        }
        else if (line.indexOf('m=') === 0) {
            processingAudioSection = false;
        }
        if (processingAudioSection) {
            if (audio_section_counter == 1) {
                if (line.includes("fmtp")) {
                    if (line.includes("stereo")) {
                        line = line.replace('stereo=1', 'stereo=0');
                    }
                }
            }
            else if (audio_section_counter == 2) {
                if (line.includes("fmtp")) {
                    if (line.includes("stereo")) {
                        line += ";maxaveragebitrate=256000";
                    }
                }
            }
        }
        newSDP += line + separator;
    });
    return newSDP;
}



//////////////////
// WEBPACK FOOTER
// ./src/sdp.ts
// module id = 343
// module chunks = 1